var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-select',{class:(_vm.prefixClass + "-size-changer"),attrs:{"size":_vm.size,"placeholder":_vm.current && _vm.itemPerPage ? _vm.current + _vm.itemPerPage : ''},on:{"change":_vm.$_onTDropDownClick}},_vm._l((_vm.range),function(i){return _c('t-option',{key:i,attrs:{"value":i,"label":i + _vm.itemPerPage}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6425f12e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/pager/sizer.vue
// module id = 757
// module chunks = 0 1 10